<div [class]="getClass()">
  <div class="header-title">
    <h3><ng-content></ng-content></h3>
  </div>
</div>

